import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendar_icon from "../../assets/images/calendar_icon.svg";
import search_icon_new from "../../assets/images/search_icon_new.svg";

const getCurrentMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return [start, end];
};

const TopHeadding = ({
  title,
  subtitle,
  spanText = "",
  spanClass = "badge",
  showDatepicker = true,
  buttons = [],
  onDateChange,
  showSearch = false,
  onSearch,
  defaultRange,
}) => {
  const [dateRange, setDateRange] = useState(defaultRange || getCurrentMonthRange);
  const [startDate, endDate] = dateRange;

  const handleChange = (range) => {
    setDateRange(range);

    if (range[0] && range[1] && onDateChange) {
      onDateChange({
        startDate: range[0],
        endDate: range[1],
      });
    }
  };

  return (
    <div className="top_headding mt_30">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-5">
            <h4 className="fs_28 fw_600 mb-0">
              {title}
              {spanText && (
                <span className={`ms-2 ${spanClass}`}>{spanText}</span>
              )}
            </h4>
            {subtitle && <p>{subtitle}</p>}
          </div>

          <div className="col-md-7 text-end">
            <div className="d-flex justify-content-end align-items-center">
              {showSearch && (
                <div className="search_field ms-auto d-flex align-items-center mr_10">
                  <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Search"
                    onChange={(e) => onSearch?.(e.target.value)}
                  />
                  <span className="serach_icon">
                    <img src={search_icon_new} alt="Search" />
                  </span>
                </div>
              )}

              {showDatepicker && (
                <div className="datepicker position-relative">
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleChange}
                    dateFormat="MM/dd/yyyy"
                    className="form-control"
                  />
                  <img
                    src={calendar_icon}
                    className="datepicker_icon"
                    alt="calendar"
                  />
                </div>
              )}

              {buttons.map((btn, index) => (
                <button
                  key={index}
                  className={`btn ${btn.className || "btn-primary"} ms-2`}
                  onClick={btn.onClick}
                  disabled={btn.disabled}
                >
                  {btn.spinner && (
                    <div className="spinner-border spinner-border-sm me-1" role="status">
                      <span className="visually-hidden">Loading</span>
                    </div>
                  )}
                  {btn.icon && <img src={btn.icon} alt="" className="me-1" />}
                  {btn.text}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeadding;
